import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { resetPassword } from "../services/auth";

import "../styles/auth.css";

export default function ResetPassword() {

    const [params] = useSearchParams();
    const navigate = useNavigate();
    const token = params.get("token") || "";

    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [done, setDone] = useState(false);

    async function handleSubmit(e) {

        e.preventDefault();
        setError("");

        if (newPassword !== confirmPassword) {
            setError("Passwords don't match.");
            return;
        }

        setLoading(true);

        try {

            await resetPassword(token, newPassword);
            setDone(true);

            setTimeout(() => navigate("/login"), 2000);

        } catch (err) {

            setError(
                err.response?.data?.message ||
                "Couldn't reset your password. The link may have expired."
            );

        } finally {

            setLoading(false);

        }

    }

    if (!token) {

        return (

            <div className="authContainer">
                <div className="authCard">
                    <h1>CercaTrova</h1>
                    <p className="authInfoText">
                        This reset link is missing its token. Please use the
                        link from your email, or request a new one.
                    </p>
                    <p><Link to="/forgot-password">Request a new link</Link></p>
                </div>
            </div>

        );

    }

    return (

        <div className="authContainer">

            <div className="authCard">

                <h1>CercaTrova</h1>
                <p>Choose a new password</p>

                {done ? (

                    <p className="authInfoText">
                        Password reset. Taking you to login...
                    </p>

                ) : (

                    <form onSubmit={handleSubmit}>

                        <input
                            type="password"
                            placeholder="New password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            minLength={8}
                            required
                        />

                        <input
                            type="password"
                            placeholder="Confirm new password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            minLength={8}
                            required
                        />

                        {error && <p className="authError">{error}</p>}

                        <button type="submit" disabled={loading}>
                            {loading ? "Resetting..." : "Reset Password"}
                        </button>

                    </form>

                )}

                <p>
                    <Link to="/login">Back to Login</Link>
                </p>

            </div>

        </div>

    );

}
